// extracted by mini-css-extract-plugin
module.exports = {"form":"ModifyRuleSensorModal_form__2BtTw","fieldset":"ModifyRuleSensorModal_fieldset__RleaP","legend":"ModifyRuleSensorModal_legend__9h-I_"};